var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86134 1.78671C3.52968 2.13837 3.33301 2.68171 3.33301 3.38837V28.6101C3.33301 29.3167 3.52968 29.8617 3.86134 30.2117L3.94634 30.2933L18.0747 16.1667V16V15.8333L3.94468 1.70337L3.86134 1.78671Z",
    fill: "url(#paint0_linear_53_197)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7835 20.8783L18.0752 16.1666V15.9999V15.8333L22.7851 11.1233L22.8918 11.1833L28.4718 14.3533C30.0651 15.2583 30.0651 16.7399 28.4718 17.6466L22.8918 20.8167L22.7835 20.8783Z",
    fill: "url(#paint1_linear_53_197)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8919 20.8166L18.0751 16L3.86182 30.2134C4.38682 30.77 5.25514 30.8383 6.23182 30.2834L22.8919 20.8166Z",
    fill: "url(#paint2_linear_53_197)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8919 11.1834L6.23182 1.71674C5.25514 1.16174 4.38682 1.23007 3.86182 1.78674L18.0751 16L22.8919 11.1834Z",
    fill: "url(#paint3_linear_53_197)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.7851 20.7117L6.23182 30.1167C5.30515 30.6433 4.47848 30.6084 3.94682 30.1284L3.86182 30.2134L3.94682 30.295C4.47848 30.7734 5.30515 30.8101 6.23182 30.2833L22.8919 20.8167L22.7851 20.7117Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M3.86134 30.0467C3.52968 29.6951 3.33301 29.15 3.33301 28.4451V28.6117C3.33301 29.3184 3.52968 29.8634 3.86134 30.2134L3.94634 30.1284L3.86134 30.0467Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M28.4713 17.48L22.7847 20.7117L22.8913 20.8183L28.4713 17.6483C29.2679 17.195 29.6663 16.5983 29.6663 16.0017C29.5996 16.54 29.193 17.07 28.4713 17.48Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M6.23134 1.88326L28.4713 14.5199C29.1947 14.9299 29.5996 15.4599 29.6664 15.9999C29.6664 15.4033 29.268 14.8066 28.4713 14.3533L6.23134 1.71659C4.63634 0.811592 3.33301 1.56326 3.33301 3.38993V3.55659C3.33301 1.72993 4.63634 0.978256 6.23134 1.88326Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_197",
    x1: 16.8212,
    y1: 3.12299,
    x2: -2.31822,
    y2: 22.2624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_197",
    x1: 30.5465,
    y1: 16.0003,
    x2: 2.95118,
    y2: 16.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_53_197",
    x1: 20.274,
    y1: 18.6174,
    x2: -5.68063,
    y2: 44.5721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_53_197",
    x1: 0.282415,
    y1: -6.60898,
    x2: 11.8722,
    y2: 4.98081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.98d4bc57461e591a06508e31d8569e65.svg";
export { ForwardRef as ReactComponent };